import React from "react";

const CalculatorIcon = ({ show }) => {
  return (
    <>
      <div onClick={show} className="icon calculator">
        <span>Calculator</span>
      </div>
    </>
  );
};

export default CalculatorIcon;
